<template>
    <component :is="component"/>
</template>
<script>
import Func60Communicator from '@/views/60/Func60Communicator.vue'

export default {
  name: 'Func60',
  data () {
    return {
      component: Func60Communicator
    }
  }
}
</script>
